import Vue from 'vue';
import Vuex from '@src/_store/store';
import en from '../locales/en/en.json';
import pt from '../locales/pt/pt.json';
import it from '../locales/it/it.json';

Vue.use(Vuex);

const initialState = JSON.parse(localStorage.getItem('@datadrive:initialState'));
let languageCode = '';
if(!initialState) {
    languageCode = 'pt';
} else {
    languageCode = initialState.languageCode;
}

let lang = {
    pt,
    en,
    it
}

export const requestStatus = {
    checkRequestStatus(statusCode, routerName) {
        if(statusCode == 401) {
            let payload = {
                show: true,
                title: lang[languageCode]['request-status-function']['title'],
                message: lang[languageCode]['request-status-function']['message'],
                iconColor: 'warning',
                iconName: 'mdi-alert-outline',
                routerName: routerName,
                statusCode: statusCode
            }
            Vuex.commit('informationModal/setInformationModalState', payload)
        }
    }
};
